jQuery( document ).ready( function($) {
	const blockName = 'jtf/jtf-jumplinks'
	console.log( '[JTF Gut Block - JS] ' + blockName + ' v2.0' )
	const JUMPLINKS_SELECTOR = '.jtf__block__jumplinks--trigger'
	if ( $( JUMPLINKS_SELECTOR ).length > 0 ) {
		$( JUMPLINKS_SELECTOR ).on( 'change', ( e ) => {
			e.preventDefault()
			e.stopPropagation()
			const externalLink = $( JUMPLINKS_SELECTOR ).val()
			if ( externalLink ) {
				window.open( externalLink, '_blank' )
			}
		} )
	}
} )

